import * as style from '../../utils/general_style.js';
import CTAButton from './CTAButton.jsx';

function CTABlock({ title, color }) {
    const divStyle = {
        ...style.COLUMN_CENTER,
        width: '49%',
        height: '150px',
        justifyContent: 'space-between',
        border: `3px solid`,
        borderImageSlice: 1,
        borderImageSource: (color === 'secondary') ? `linear-gradient(160deg, ${style.COLORS.secondary}, ${style.COLORS.primary})` : `linear-gradient(160deg, ${style.COLORS.primary}, ${style.COLORS.secondary})`,
    };

	return (
        <div style={{...divStyle, ...style.ELEMENT_BLOCK_WHITE}}>
            <div style={{textAlign: 'center'}}>
                <h2 style={{marginBottom: '0'}}>{title}</h2>
                <p>Faites votre demande de devis en ligne</p>
            </div>
            <CTAButton />
        </div>
	);
};

export default CTABlock;